import { DownOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Dropdown, Menu } from "antd";
import useAuth from "../../hooks/useAuth";
import { formatCUITCUILWithDash } from "../../utils/utils";
import "./loggedUser.css";

const LoggedUser = () => {
    const { user, logout } = useAuth();

    const menu = (
        <Menu
            style={{ width: "160px" }}
            items={[
                // {
                //     label: "Mis datos",
                //     key: "0",
                // },
                {
                    label: (
                        <div onClick={logout}>
                            <LogoutOutlined /> Salir
                        </div>
                    ),
                    key: "1",
                },
            ]}
        />
    );

    return (
        <div className='logged-user'>
            {user ? (
                <Dropdown overlay={menu} trigger={["click"]}>
                    <a
                        style={{ margin: "10px", color: "black" }}
                        onClick={(e) => e.preventDefault()}
                    >
                        <>
                            <UserOutlined style={{ margin: "0 10px" }} />
                            {formatCUITCUILWithDash(user.cuit).toUpperCase()}
                            <DownOutlined style={{ margin: "0 10px" }} />
                        </>
                    </a>
                </Dropdown>
            ) : null}
        </div>
    );
};

export default LoggedUser;
